<div *ngIf="!props.hidden"
  class="mb-2">
  <ng-template #fieldComponent></ng-template>

  <div *ngIf="showError"
    class="invalid-feedback"
    [style.display]="'block'">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>

</div>